import { testFbAuth, testFbId, testFbStorage } from './index'
import { createDutyObject } from './duties'
import { cloudFunctionsUrl, version, PARTNER } from '@/constants'
import { httpDelete } from '@/services/api/http'
import { getUserUID } from '@/services/endpoints/session'
import { valueToTime, valueToDB } from '@/functions'
import { formatDbTime, durationToMinutes } from '@/mixins/utils'
// import { isValidGroupImage } from '@/functions/groups'
import userProfileBroken from '@/assets/images/user-profile-broken.png'

import moment from 'moment'
import 'moment/locale/pt-br'
moment.locale('pt-BR')

//
// FUNÇÕES AUXILIARES PARA CÁLCULO DE VALOR DO PLANTÃO
//

const getPeriodName = (hourStr) => {
  const hour = parseInt(hourStr.split(':')[0])
  return hour >= 17 ? 'night' : 'day'
}

const getTypeWeek = (dateStr) => {
  const dayOfWeek = moment(dateStr).day()
  return (dayOfWeek === 0 || dayOfWeek === 6) ? 'weekend' : 'weekdays'
}

const findRuleByPriorityHierarchy = (props) => {
  const { rules, period, typeWeek } = props

  if (!rules || typeof rules !== 'object') return null

  const specificKey = `${typeWeek}_${period}`
  if (rules[specificKey] && rules[specificKey].value > 0) {
    return rules[specificKey].value
  }

  if (rules[period] && rules[period].value > 0) {
    return rules[period].value
  }

  return null
}

const calculateAutomaticDutyValue = (userData, scaleData, dateStr, timeStr, durationStr, turnFixedValue) => {
  if (turnFixedValue > 0) {
    return turnFixedValue
  }

  if (!userData && (!scaleData || !scaleData.hourlyrate)) {
    if (!scaleData) return 0
  }


  const typeWeek = getTypeWeek(dateStr)
  const periodName = getPeriodName(timeStr)
  const totalMinutes = durationToMinutes(durationStr)


  let hourlyRate = 0

  if (userData) {
    if (typeWeek === 'weekdays') {
      hourlyRate = findRuleByPriorityHierarchy({
        rules: userData.weekdaysNight || {},
        period: 'night',
        typeWeek: 'weekdays'
      })

      if (!hourlyRate) {
        hourlyRate = findRuleByPriorityHierarchy({
          rules: userData.weekdaysDay || {},
          period: 'day',
          typeWeek: 'weekdays'
        })
      }

      if (!hourlyRate && userData.weekdaysGeneral && userData.weekdaysGeneral.value > 0) {
        hourlyRate = userData.weekdaysGeneral.value
      }
    } else if (typeWeek === 'weekend') {
      hourlyRate = findRuleByPriorityHierarchy({
        rules: userData.weekendNight || {},
        period: 'night',
        typeWeek: 'weekend'
      })

      if (!hourlyRate) {
        hourlyRate = findRuleByPriorityHierarchy({
          rules: userData.weekendDay || {},
          period: 'day',
          typeWeek: 'weekend'
        })
      }

      if (!hourlyRate && userData.weekendGeneral && userData.weekendGeneral.value > 0) {
        hourlyRate = userData.weekendGeneral.value
      }
    }
  }

  if (!hourlyRate) {
    if (userData && periodName === 'night' && userData.nightGeneral && userData.nightGeneral.value > 0) {
      hourlyRate = userData.nightGeneral.value
    }
    else if (userData && periodName === 'day' && userData.dayGeneral && userData.dayGeneral.value > 0) {
      hourlyRate = userData.dayGeneral.value
    }
    // Estrutura ATUAL do usuário - weekendDayShiftHourlyRate / weekendNightShiftHourlyRate
    else if (userData && typeWeek === 'weekend' && periodName === 'day' && userData.weekendDayShiftHourlyRate && userData.weekendDayShiftHourlyRate > 0) {
      hourlyRate = userData.weekendDayShiftHourlyRate
    }
    else if (userData && typeWeek === 'weekend' && periodName === 'night' && userData.weekendNightShiftHourlyRate && userData.weekendNightShiftHourlyRate > 0) {
      hourlyRate = userData.weekendNightShiftHourlyRate
    }
    else if (userData && typeWeek === 'weekdays' && periodName === 'day' && userData.weekdaysDayShiftHourlyRate && userData.weekdaysDayShiftHourlyRate > 0) {
      hourlyRate = userData.weekdaysDayShiftHourlyRate
    }
    else if (userData && typeWeek === 'weekdays' && periodName === 'night' && userData.weekdaysNightShiftHourlyRate && userData.weekdaysNightShiftHourlyRate > 0) {
      hourlyRate = userData.weekdaysNightShiftHourlyRate
    }
    // Estrutura ANTIGA/SIMPLES do usuário - weekendHourlyRate / weekdaysHourlyRate
    else if (userData && typeWeek === 'weekend' && userData.weekendHourlyRate && userData.weekendHourlyRate > 0) {
      hourlyRate = userData.weekendHourlyRate
    }
    else if (userData && typeWeek === 'weekdays' && userData.weekdaysHourlyRate && userData.weekdaysHourlyRate > 0) {
      hourlyRate = userData.weekdaysHourlyRate
    }
    else if (userData && userData.hourlyrate && userData.hourlyrate > 0) {
      hourlyRate = userData.hourlyrate
    }
    // Fallback para valores da escala (estrutura ATUAL - weekendDayShiftHourlyRate / weekendNightShiftHourlyRate)
    else if (scaleData && typeWeek === 'weekend' && periodName === 'day' && scaleData.weekendDayShiftHourlyRate && scaleData.weekendDayShiftHourlyRate > 0) {
      hourlyRate = scaleData.weekendDayShiftHourlyRate
    }
    else if (scaleData && typeWeek === 'weekend' && periodName === 'night' && scaleData.weekendNightShiftHourlyRate && scaleData.weekendNightShiftHourlyRate > 0) {
      hourlyRate = scaleData.weekendNightShiftHourlyRate
    }
    else if (scaleData && typeWeek === 'weekdays' && periodName === 'day' && scaleData.weekdaysDayShiftHourlyRate && scaleData.weekdaysDayShiftHourlyRate > 0) {
      hourlyRate = scaleData.weekdaysDayShiftHourlyRate
    }
    else if (scaleData && typeWeek === 'weekdays' && periodName === 'night' && scaleData.weekdaysNightShiftHourlyRate && scaleData.weekdaysNightShiftHourlyRate > 0) {
      hourlyRate = scaleData.weekdaysNightShiftHourlyRate
    }
    // Fallback para valores da escala (estrutura ANTIGA/SIMPLES - weekendHourlyRate / weekdaysHourlyRate)
    else if (scaleData && typeWeek === 'weekend' && scaleData.weekendHourlyRate && scaleData.weekendHourlyRate > 0) {
      hourlyRate = scaleData.weekendHourlyRate
    }
    else if (scaleData && typeWeek === 'weekdays' && scaleData.weekdaysHourlyRate && scaleData.weekdaysHourlyRate > 0) {
      hourlyRate = scaleData.weekdaysHourlyRate
    }
    else if (scaleData && periodName === 'day' && scaleData.dayShiftHourlyRate && scaleData.dayShiftHourlyRate > 0) {
      hourlyRate = scaleData.dayShiftHourlyRate
    }
    else if (scaleData && periodName === 'night' && scaleData.nightShiftHourlyRate && scaleData.nightShiftHourlyRate > 0) {
      hourlyRate = scaleData.nightShiftHourlyRate
    }
    // Fallback para valor base da escala (hourlyrate)
    else if (scaleData && scaleData.hourlyrate && scaleData.hourlyrate > 0) {
      hourlyRate = scaleData.hourlyrate
    }
  }


  if (hourlyRate > 0) {
    const newDutyValue = (totalMinutes / 60) * hourlyRate
    return parseFloat(newDutyValue.toFixed(2))
  }

  return 0
}

//
// API
//

export const rgxFirebaseKey = /(([A-Za-z0-9\-_]){10,256})+/
// export const rgxFirebaseKey = /(([A-Za-z0-9\-\_]){10,256})+/

export const fbFullUpdate = object => new Promise((resolve) => {
  try {
    testFbId.ref().update(object, error => {
      if (error) {
        resolve({ code: 0, response: '', error })
      } else {
        resolve({ code: 1, response: '', error: '' })
      }
    })
  } catch (error) {
    resolve({ code: 0, response: '', error })
  }
})

export const apiMassiveUpdate = (updates, customCallback) => {
  try {
    testFbId.ref().update(updates, error => {
      if (error) {
        customCallback({ code: 0, message: 'Não foi possível atualizar os dados. Por favor, tente novamente ou contate nosso suporte.', error })
      } else {
        customCallback({ code: 1, message: '', error: '' })
      }
    })
  } catch (error) {
    customCallback({ code: 0, message: 'Não foi possível atualizar os dados. Por favor, tente novamente ou contate nosso suporte.', error })
  }
}

//
//
//

export const apiGetUserIdByEmail = async email => {
  try {
    const response = await fetch(`${cloudFunctionsUrl}/getUserIdByEmail?email=${encodeURIComponent(email)}`)
    const data = response.ok ? await response.json() : null

    return response.ok ? { code: data.code, data: data.data } : { code: 0, data: null }
  } catch (error) {
    return { code: 0, data: error }
  }
}

//
// ?
//

export const apiGetCurrentUser = () => {
  return !!testFbAuth === true && !!testFbAuth.currentUser === true ? testFbAuth.currentUser : false
}

//
// USADO SOMENTE NO duties.js
//

export const apiGetUserId = () => {
  const requesterSession = apiGetCurrentUser()
  return !!requesterSession === true ? requesterSession.uid : false
}

export const apiCheckUserDutyConflictInGroup = async (groupID, userID, selectedDate, selectedTurnTime) => {
  const scales = await getScalesByGroupID(groupID)

  if (scales.length === 0) return []

  const selectedStartTime = formatDbTime(selectedTurnTime) // durationToMinutes(formatDbTime(selectedTurnTime))

  const foundDuties = []

  scales.forEach(([scaleID, scale]) => {
    Object.entries(scale.turnos).forEach(([_, turn]) => {
      const processedStartTime = formatDbTime(turn.hour)

      const turnDuties = !!turn.plantoes === true ? Object.entries(turn.plantoes) : []

      if (selectedStartTime === processedStartTime && turnDuties.length > 0)
      {
        turnDuties.forEach(([dateYmd, date]) => {
          const turnReleasedDates = !!date.users === true ? Object.values(date.users) : []

          if (dateYmd === selectedDate && turnReleasedDates.length > 0)
          {
            const amount = turnReleasedDates.filter(editDuty => !!editDuty.uid === true && editDuty.uid === userID && !editDuty._deletedFromAcompanhar).length

            if (amount > 0) {
              foundDuties.push({ scaleID, scaleName: String(scale.type || '').trim(), duration: formatDbTime(turn.duration), amount })
            }
          }
        })
      }
    })
  })

  return foundDuties
}

export const apiIsUserInDuty = async (groupID, scaleID, turnID, date, userID) => {
  try {
    const s = await testFbId.ref(`escalas/${groupID}/${scaleID}/turnos/${turnID}/plantoes/${date}/users`).orderByChild('uid').equalTo(userID).once('value')
    if (!s || !s.val()) return false
    return Object.values(s.val()).some(entry => !entry._deletedFromAcompanhar)
  } catch (e) {
    return false
  }
}

export const apiGetTurnDutyUsers = async (groupID, scaleID, turnID, date) => {
  const snapshot = await testFbId.ref('escalas' + '/' + groupID + '/' + scaleID + '/' + 'turnos' + '/' + turnID + '/' + 'plantoes' + '/' + date + '/' + 'users').once('value')
  return (snapshot && snapshot.val()) ? snapshot.val() : false
}

export const apiGetTurnDays = async (groupID, scaleID, turnID) => {
  const snapshot = await testFbId.ref('escalas' + '/' + groupID + '/' + scaleID + '/' + 'turnos' + '/' + turnID).once('value')
  return (snapshot && snapshot.val()) ? snapshot.val() : false
}

export const apiIsUserAdmin = async (userID, groupID) => {
  const snapshot = await testFbId.ref('users/' + userID + '/grupos/' + groupID + '/admin').once('value')
  return (snapshot && snapshot.val()) ? snapshot.val() : false
}

/**
 *
 * FUNCTIONS
 *
 */

export const apiGenerateEntityID = path => {
  const entityKey = testFbId.ref(path).push().key
  return entityKey
}

export const apiGetScaleRef = (groupID, scaleID) => {
  return testFbId.ref('escalas/' + groupID + '/' + scaleID)
}

export const apiGetScale = async (groupID, scaleID) => {
  const snapshot = await testFbId.ref('escalas/' + groupID + '/' + scaleID).once('value')
  return snapshot && snapshot.val() ? snapshot.val() : false
}

/*
// [staging-portaltelemedicina / master-portaltelemedicina]
export const apiGetScaleConsultationDuration = async (groupID, scaleID) => {
  const snapshot = await testFbId.ref('escalas/' + groupID + '/' + scaleID + '/tempo_consulta').once('value')
  if (!!snapshot === false) return 0
  return parseInt(snapshot.val() || '0')
}
// [staging-portaltelemedicina / master-portaltelemedicina]
*/

export const apiGetScaleCode = async (groupID, scaleID) => {
  const snapshot = await testFbId.ref('escalas/' + groupID + '/' + scaleID + '/urlcode').once('value')
  return !!snapshot === true && !!snapshot.val() === true ? String(snapshot.val()) : ''
}

export const apiGetGroupCode = async groupID => {
  const snapshot = await testFbId.ref('grupos/' + groupID + '/urlcode').once('value')
  return !!snapshot === true && !!snapshot.val() === true ? String(snapshot.val()) : ''
}

/**
 *
 *
 *
 */

export const apiRefOpen = (ref, callback) => {
  ref.on('value', callback)
}

export const apiRefClose = (ref, callback) => {
  ref.off('value', callback)
}

export const apiUpdateScaleTurnValue = async (groupID, scaleID, turnID, value, cCallback) => {
  try {
    testFbId.ref(`escalas/${groupID}/${scaleID}/turnos/${turnID}/value`).set(value,
    error => {
      if (error) {
        cCallback({
          code: 0,
          message: 'Não foi possível atualizar o valor do turno',
          error: error,
        })
      } else {
        cCallback({
          code: 1,
          message: 'Valor do turno alterado!',
          error: '',
        })
      }
    })
  } catch (e) {
    cCallback({
      code: 0,
      message: 'Não foi possível atualizar o valor do turno',
      error: e,
    })
  }
}

export const apiUpdateTurnDutiesValue = async (groupID, scaleID, turnID, turnHour = false, newValue = 0, month = false, year = false, cCallback = () => {}) => {
  const type = month !== false && year !== false && turnHour !== false ? 'current' : 'all'

  //
  // ?
  //

  const updates = {}

  //
  // ATUALIZA VALOR DO TURNO
  //

  updates[`escalas/${groupID}/${scaleID}/turnos/${turnID}/value`] = newValue

  //
  // LOAD TURN DUTIES
  //

  const turnSnapshot = await testFbId.ref(`escalas/${groupID}/${scaleID}/turnos/${turnID}`).once('value')
  const turn = turnSnapshot && turnSnapshot.val() ? turnSnapshot.val() : false

  if (!!turn && !!turn.plantoes)
  {
    const baseMonth = month !== false ? parseInt(month) : ''
    const baseYear = year !== false ? parseInt(year) : ''

    // console.log('::: MONTH/YEAR:', type === 'current' ? `${baseYear}-${baseMonth}-` : 'all')

    Object.entries(turn.plantoes).forEach(([date, dateData]) => {
      const isValid = (type === 'current' && date.indexOf(`${baseYear}-${baseMonth}-`) !== -1) || type === 'all'

      if (isValid) {
        const plantoes = !!dateData && !!dateData.plantoesIDs ? Object.keys(dateData.plantoesIDs) : []
        // const plantoes = !!dateData && dateData.hasOwnProperty('plantoesIDs') ? Object.keys(dateData.plantoesIDs) : []

        if (plantoes.length > 0) {
          plantoes.forEach(plantaoID => {
            updates[`plantoes/${plantaoID}/valor`] = newValue
          })
        }

        // console.log(`::: Plantões do turno "${turnID}" no dia ${date}:`, plantoes)
      }
    })
  }

  //
  // ATUALIZA DADOS NO BANCO

  testFbId.ref().update(updates,
  error => {
    if (error) {
      cCallback({
        code: 0,
        message: '',
        error,
      })
    } else {
      cCallback({
        code: 1,
        message: 'O valor do turno e dos plantões foram alterados!',
        error: '',
      })
    }
  })
}

export const apiCreateShift = async (groupID, scaleID, weekDays, hour, duration, value, name) => {
  const newShiftID = apiGenerateEntityID(`escalas/${groupID}/${scaleID}/turnos`)

  const updates = {
    [`escalas/${groupID}/${scaleID}/turnos/${newShiftID}/grupo`]: groupID,
    [`escalas/${groupID}/${scaleID}/turnos/${newShiftID}/escala`]: scaleID,
    [`escalas/${groupID}/${scaleID}/turnos/${newShiftID}/days`]: weekDays,
    [`escalas/${groupID}/${scaleID}/turnos/${newShiftID}/hour`]: hour,
    [`escalas/${groupID}/${scaleID}/turnos/${newShiftID}/duration`]: duration,
    [`escalas/${groupID}/${scaleID}/turnos/${newShiftID}/value`]: value,
  }

  if (name) updates[`escalas/${groupID}/${scaleID}/turnos/${newShiftID}/name`] = name

  // ATUALIZA DADOS NO BANCO

  return new Promise((resolve, reject) => {
    try {
      testFbId.ref().update(updates,
      error => {
        if (error) {
          resolve({ code: 0, title: 'Atenção!', message: 'Não foi possível criar o turno', error })
        } else {
          resolve({ code: 1, title: 'Feito!', message: newShiftID, error: '' })
        }
      })
    } catch (e) {
      resolve({ code: 0, title: 'Atenção!', message: 'Não foi possível criar o turno', error: e })
    }
  })
}

//
//
//

export const apiDeleteScaleTurn = async (groupID, scaleID, turnID, cCallback) => {
  // testFbId.ref('escalas/' + this.groupID + '/' + this.scaleID + '/turnos/' + turnID).remove()

  try {
    testFbId.ref(`escalas/${groupID}/${scaleID}/turnos/${turnID}`).set(null,
    error => {
      if (error) {
        cCallback({
          code: 0,
          message: 'Não foi possível excluir o turno',
          error: error,
        })
      } else {
        cCallback({
          code: 1,
          message: 'O turno foi excluído!',
          error: '',
        })
      }
    })
  } catch (e) {
    cCallback({
      code: 0,
      message: 'Não foi possível excluir o turno',
      error: e,
    })
  }
}

//
//
//
//
//
//
//
//
//

export const apiUpdateScaleName = (groupID, scaleID, scaleName) => {
  return new Promise((resolve, reject) => {
    //
    // ATUALIZA DADOS NO BANCO

    try {
      testFbId.ref(`escalas/${groupID}/${scaleID}/type`).set(scaleName,
      error => {
        if (error) {
          resolve({
            code: 0,
            response: 'Não foi possível atualizar o nome da escala. Por favor, tente novamente ou entre em contato com o suporte técnico.',
            error,
          })
        } else {
          resolve({
            code: 1,
            response: '',
            error: '',
          })
        }
      })
    } catch (e) {
      resolve({
        code: 0,
        response: 'Não foi possível atualizar o nome da escala. Por favor, tente novamente ou entre em contato com o suporte técnico.',
        error: e,
      })
    }
  })
}

export const apiUpdateScale = async args => {
  return new Promise((resolve, reject) => {

    const data = {
      // Nome da escala
      type: args.scaleName,
      // Valor da escala
      value: typeof args.scaleValue === 'number' ? args.scaleValue : 0,
      // Valores de precificação detalhada
      weekdaysHourlyRate: typeof args.weekdaysHourlyRate === 'number' ? args.weekdaysHourlyRate : 0,
      weekendHourlyRate: typeof args.weekendHourlyRate === 'number' ? args.weekendHourlyRate : 0,
      dayShiftHourlyRate: typeof args.dayShiftHourlyRate === 'number' ? args.dayShiftHourlyRate : 0,
      nightShiftHourlyRate: typeof args.nightShiftHourlyRate === 'number' ? args.nightShiftHourlyRate : 0,
      weekdaysDayShiftHourlyRate: typeof args.weekdaysDayShiftHourlyRate === 'number' ? args.weekdaysDayShiftHourlyRate : 0,
      weekdaysNightShiftHourlyRate: typeof args.weekdaysNightShiftHourlyRate === 'number' ? args.weekdaysNightShiftHourlyRate : 0,
      weekendDayShiftHourlyRate: typeof args.weekendDayShiftHourlyRate === 'number' ? args.weekendDayShiftHourlyRate : 0,
      weekendNightShiftHourlyRate: typeof args.weekendNightShiftHourlyRate === 'number' ? args.weekendNightShiftHourlyRate : 0,
      // LOCAL DA ESCALA (SE HOUVER) -> Nome do local (FIXO ou PERSONALIZADO)
      local: args.scaleLocation.name,
      // COMEÇAR SEMANA NA SEGUNDA?
      // startOnMonday: args.startOnMonday,
      // MÁXIMO DE PLANTÕES POR USUÁRIO NESSA ESCALA
      maxshifts: args.scaleMaxShifts,
      // DIAS DE INÍCIO E FIM DA ESCALA NO MÊS
      startDayOfMonth: args.startDayOfMonth,
      endDayOfMonth: args.endDayOfMonth,
      // AÇÕES DE PLANTÃO
      allowDutySplitting: args.allowBreakDuringDuty || null,
      // AVAILABLE SHIFTS COLOR
      availableShiftsColor: args.availableShiftsColor,
      // OWNED SHIFTS COLOR
      ownedShiftsColor: args.ownedShiftsColor,

      /*
      // [staging-portaltelemedicina / master-portaltelemedicina]
      tempo_consulta: args.scaleConsultationDuration,
      // requirePatient = true (opcional)
      requirePatient: args.requirePatient === false ? true : null,
      // requirePatient: args.requirePatient === '0' ? true : null,
      slotsFromOwnedDutiesOnly: args.slotsFromOwnedDutiesOnly || null,
      // [staging-portaltelemedicina / master-portaltelemedicina]
      */
    }

    // LOCAL DA ESCALA (SE HOUVER) -> Identificador do local (Somente FIXO)
    data.placeID = args.scaleLocation.presetLocations && args.scaleLocation.id.length > 0 ? args.scaleLocation.id : null

    //
    // ATUALIZA DADOS NO BANCO

    try {
      testFbId.ref(`escalas/${args.groupID}/${args.scaleID}`).update(data,
      error => {
        if (error) {
          resolve({
            code: 0,
            response: 'Não foi possível atualizar os detalhes da escala. Por favor, tente novamente ou entre em contato com o suporte técnico.',
            error,
          })
        } else {
          resolve({
            code: 1,
            response: '',
            error: '',
          })
        }
      })
    } catch (e) {
      resolve({
        code: 0,
        response: 'Não foi possível atualizar os detalhes da escala. Por favor, tente novamente ou entre em contato com o suporte técnico.',
        error: e,
      })
    }
  })
}

//
// NOTA:
// APAGAR ESCALA TEM POTENCIAL PARA ULTRAPASSAR O LIMITE DE UPDATES DO FIREBASE (1000 ?)
//

export const apiDeleteScale = (groupID, scaleID) => httpDelete({
  route: `api/v1/groups/${groupID}/scales/${scaleID}`,
  headers: {
    "X-Client-Type": "WEB",
    "X-Partner": PARTNER,
    "X-App-Version": version,
    "X-User-ID": getUserUID()
  }
})

export const apiRenewScaleLink = async (groupID, scaleID) => {
  const updates = {
    [`escalas/${groupID}/${scaleID}/urlcode`]: ((+new Date()) + Math.random() * 1000).toString(36),
  }

  return new Promise((resolve, reject) => {
    // ATUALIZA DADOS NO BANCO
    const response = 'Desculpe, não foi possível renovar o link da escala. Por favor, entre em contato com o suporte técnico.'
    try {
      testFbId.ref().update(updates,
      error => {
        resolve({ code: error ? 0 : 1, title: error ? 'Atenção!' : 'Sucesso!', response: error ? response : 'O link da escala foi renovado! Agora compartilhe o novo link com os usuários, pois o link antigo foi bloqueado.', error: error || '' })
      })
    } catch (e) {
      resolve({ code: 0, title: 'Atenção!', response, error: e })
    }
  })
}

export const apiRenewGroupLink = async groupID => {
  const updates = {
    [`grupos/${groupID}/urlcode`]: ((+new Date()) + Math.random() * 1000).toString(36),
  }

  return new Promise((resolve, reject) => {
    // ATUALIZA DADOS NO BANCO
    const response = 'Desculpe, não foi possível renovar o link do grupo. Por favor, entre em contato com o suporte técnico.'
    try {
      testFbId.ref().update(updates,
      error => {
        resolve({ code: error ? 0 : 1, title: error ? 'Atenção!' : 'Sucesso!', response: error ? response : 'O link do grupo foi renovado! Agora compartilhe o novo link com os usuários, pois o link antigo foi bloqueado.', error: error || '' })
      })
    } catch (e) {
      resolve({ code: 0, title: 'Atenção!', response, error: e })
    }
  })
}

export const apiGetGroupNewWeekChatMessages = async (groupID, firstDayOfWeek) => {
  const snapshot = await testFbId.ref('chats/' + groupID + '/chats').orderByChild('referer').equalTo(firstDayOfWeek).once('value')
  return (snapshot && snapshot.val()) ? snapshot.val() : false
}

// Fix Warning (ESSE WARNING DEU QUANDO ESTAVA DISPARANDO A SEMANA DO PLANTÃO NA TELA DO EDITAR ESCALA) - SOLUÇÃO É O CÓDIGO ABAIXO
// [2025-08-08T19:08:45.697Z]  @firebase/database: FIREBASE WARNING: Using an unspecified index. Your data will be downloaded and filtered on the client. Consider adding ".indexOn": "referer" at /chats/-OLJvCWPPc-1smOeRmKV/chats to your security rules for better performance.
// export const apiGetGroupNewWeekChatMessages = async (groupID, firstDayOfWeek) => {
//   const snapshot = await testFbId.ref('chats/' + groupID + '/chats').once('value')
//   const chats = (snapshot && snapshot.val()) ? snapshot.val() : {}

//   // Filtra no cliente para evitar o warning do Firebase
//   const filteredChats = {}
//   Object.keys(chats).forEach(chatKey => {
//     const chat = chats[chatKey]
//     if (chat && chat.referer === firstDayOfWeek) {
//       filteredChats[chatKey] = chat
//     }
//   })

//   return Object.keys(filteredChats).length > 0 ? filteredChats : false
// }

export const apiGetGroupScaleTurns = async (groupID, scaleID) => {
  const snapshot = await testFbId.ref(`escalas/${groupID}/${scaleID}/turnos`).once('value')
  return (snapshot && snapshot.val()) ? snapshot.val() : false
}

export const getScalesByGroupID = groupID => {
  return new Promise((resolve, reject) => {
    testFbId.ref(`escalas/${groupID}`).once('value').then(snapshot => {
      resolve(snapshot && snapshot.exists() ? Object.entries(snapshot.val()) : [])
    })
    .catch((e) => {
      resolve([])
    })
  })
}

export const getDutyById = async dutyID => {
  const snapshot = await testFbId.ref(`plantoes/${dutyID}`).once('value')
  return (snapshot && snapshot.exists()) ? snapshot.val() : null
}

export const getScaleByID = async (groupID, scaleID) => {
  const request = await testFbId.ref(`escalas/${groupID}/${scaleID}`).once('value')
  return (request && request.val()) ? request.val() : false
}

export const getGroupByID = async groupID => {
  const groupRequest = await testFbId.ref(`grupos/${groupID}`).once('value')
  return (groupRequest && groupRequest.val()) ? groupRequest.val() : false
}

export const getUserByID = async userID => {
  const userRequest = await testFbId.ref(`users/${userID}`).once('value')
  const user = (userRequest && userRequest.val()) ? userRequest.val() : false

  if (user && typeof user === 'object')
  {
    user.uid = userID
    user.userImage = Object.prototype.hasOwnProperty.call(user, 'img') && String(user.img).indexOf('https://') !== -1 ? String(user.img) : userProfileBroken
    user.userName = Object.prototype.hasOwnProperty.call(user, 'nome') ? String(user.nome).trim() : ''
    user.userEmail = Object.prototype.hasOwnProperty.call(user, 'email') ? String(user.email).trim() : ''

    // user.userID = userID // DO APP
    // user.admin = !!group.users[userID].admin // DO APP
  }

  return user
}

export const getUserByUserID = userID => testFbId.ref(`users/${userID}`).once('value').then(x => x.exists() ? x.val() : null).catch(() => null)

export const apiGetUserDetails = async userID => {
  const request = await testFbId.ref(`users/${userID}`).once('value')
  const result = (request && request.val()) ? request.val() : false
  const user = (result && typeof result === 'object') ? result : false

  if (!!user === false) return false

  // && !!eventOwner.nome && eventOwner.nome.trim().length > 0 ? eventOwner.nome.trim() :
  // userImage: !!eventOwner && !!eventOwner.img && this.isValidGroupImage(eventOwner.img) ? eventOwner.img : this.userProfileBroken,

  const isValidImage = !!user && !!user.img && typeof user.img === 'string' && user.img.indexOf('https://') !== -1
  const userName = !!user && !!user.nome === true && user.nome.trim().length > 0 ? user.nome.trim() : ''

  return {
    ...user,
    img: isValidImage ? user.img : '',
    nome: userName,
  }
}

//
// ---------------------------------------------------------------------------------
// ExportTimesheetModal
// ExportTimesheetSimulationModal
// ---------------------------------------------------------------------------------
//

const processGroupParticipantsList = async group => {
  if (!!group === false || (!!group === true && !!group.users === false)) return []

  const userKeys = Object.keys(group.users)

  const usersList = userKeys.length > 0 ? await Promise.all(
    userKeys.map(async userID => await getUserByID(userID)).filter(userID => userID && typeof userID === 'object')
  ) : []

  // if (usersList.length > 0) users = usersList.sort((a, b) => a.nome.localeCompare(b.nome))
  if (usersList.length > 0) usersList.sort((a, b) => a.nome.localeCompare(b.nome))

  return usersList
}

export const getGroupUsers = async groupID => await processGroupParticipantsList(await getGroupByID(groupID))

/**
 *
 * ?
 *
 */

export const apiUploadGroupImage = async (groupID, groupImage, groupImageType) => {
  return new Promise((resolve, reject) => {
    /* --- REFERÊNCIA --- */
    const storageRef = testFbStorage.ref(`images/groups/${groupID}`)

    /* --- ENVIA --- */
    const uploadTask = storageRef.put(groupImage, { contentType: groupImageType })
    uploadTask.on(
      'state_changed',
      uploadSnapshot => {
        // [24/01/25] const uploadProgress = (uploadSnapshot.bytesTransferred / uploadSnapshot.totalBytes) * 100
        // [24/01/25] console.log(`::: GROUP "${groupID}" -> Upload is ${uploadProgress}% done`)
      },
      uploadError => {
        resolve({
          code: 0,
          response: uploadError,
        })
      },
      () => uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
        resolve({
          code: 1,
          response: downloadURL,
        })
      }),
    )
  })
}

/**
 *
 * ?
 *
 */

const dateToNumber = date => {
  const d = date.split('-')

  // [0] = YEAR / [1] = MONTH / [2] = DAY
  d[1] = String(d[1]).padStart(2, '0')
  d[2] = String(d[2]).padStart(2, '0')

  return parseInt(d.join(''))
}

const getWorkingDays = (weeks = [], diasDoTurno = [], dataSemZero, jornada, journeyWorkingDays, journeyDaysOff) => {
  //
  // LÊ OS DIAS DA SEMANA QUE FAZEM PARTE DO TURNO (QUE O USUÁRIO ESTÁ SENDO INSERIDO)
  //

  const valoresDosDiasDoTurno = Object.values(diasDoTurno)

  // console.log('::: getWorkingDays => DIAS DA SEMANA QUE FAZEM PARTE DO TURNO:', diasDoTurno, valoresDosDiasDoTurno)

  //
  // LÊ OS DIAS DO PERÍODO SELECIONADO. EXEMPLO: Janeiro de 2022
  //

  let dates = []

  weeks.forEach(week => {
    week.value.forEach(weekDay => {
      dates.push({ isReleasedWeek: week.isReleasedWeek, dataSemZero: weekDay.dayFmtWzero })
    })
  })

  //
  // FILTRA OS DIAS QUE:
  // - Vem depois do dia selecionado
  // - Fazem parte da jornada selecionada
  // - Fazem parte do turno selecionado
  //

  const selectedDate = dateToNumber(dataSemZero)

  dates = dates.filter(date => dateToNumber(date.dataSemZero) >= selectedDate)

  // console.log(`::: getWorkingDays => PROCESSAR DATAS À PARTIR DO DIA ${dataSemZero} (${selectedDate})`)

  //
  // DEFINE O INTERVALO ENTRE "DIAS TRABALHÁVEIS" E "DIAS DE DESCANSO" CONFORME A JORNADA SELECIONADA
  //

  let workingDays = 0 // keep
  let restingDays = 0 // skip

  if (jornada === '12x36') { workingDays = 1; restingDays = 1 } // SIM, NÃO, SIM...
  if (jornada === '12x48') { workingDays = 1; restingDays = 2 } // SIM, NÃO, NÃO, SIM...
  if (jornada === '12x72') { workingDays = 1; restingDays = 3 } // SIM, NÃO, NÃO, NÃO, SIM...
  if (jornada === 'Semanal') { workingDays = 1; restingDays = 6 } // SIM, NÃO, NÃO, NÃO, NÃO, NÃO, NÃO, SIM...
  if (jornada === '5x2') { workingDays = 5; restingDays = 2 } // ?
  if (jornada === '6x1') { workingDays = 6; restingDays = 1 } // ?
  if (jornada === 'Personalizado') { workingDays = Number(journeyWorkingDays); restingDays = Number(journeyDaysOff) }

  if (workingDays > 0 && restingDays > 0) dates = dates.filter((_, index) => (index % (workingDays + restingDays)) < workingDays)

  // console.log(`::: getWorkingDays => JORNADA ${jornada}: UM PLANTÃO DURANTE ${workingDays} DIA(S) COM INTERVALO DE ${restingDays} DIA(S)`)

  //
  // SELECIONA OS DIAS QUE FAZEM PARTE DO TURNO SELECIONADO
  //
  // SENHOR JESUS - testar moment updateLocale
  //

  if (diasDoTurno.length !== 7)
  {
    dates = dates.filter(date => {
      const dateDay = moment(date.dataSemZero, 'YYYY-M-D').day()
      return valoresDosDiasDoTurno.some(turnDay => turnDay === dateDay) // dayExistsInTurn
    })
  }

  // console.log(`::: getWorkingDays => DIAS QUE FAZEM PARTE DO TURNO E ESTÃO DENTRO DA JORNADA ${jornada}:`, dates)

  //
  // OUTPUT
  //

  return dates
}

//
//
//
// CREATE SHIFT
//
//
//

const addScaleShift = (args = {
  /*
  // [staging-portaltelemedicina / master-portaltelemedicina]
  slotType: "",
  scaleConsultationDuration: false,
  // [staging-portaltelemedicina / master-portaltelemedicina]
  */

  user: { availableTurn: true },
  userScaleHourlyRate: 0,
  userData: null, // Objeto completo do usuário com todas as regras de precificação
  scaleData: null, // Objeto com as regras de precificação da escala
  //
  //
  //
  //
  turnID: '',
  dataSemZero: '', // YYYY-M-D
  turnoDados: null,
  groupID: '',
  scaleID: '',
  grupoNome: '',
  scaleName: '',
  scaleLocation: '',
  createShift: false,
}) => {
  const isAvailableShift = !!args.user.availableTurn === true
  const dataSemZero = args.dataSemZero.split('-')
  const yyyymd = `${dataSemZero[0]}-${dataSemZero[1]}-${dataSemZero[2]}`
  const ddmmyyyy = `${dataSemZero[2].padStart(2, '0')}/${dataSemZero[1].padStart(2, '0')}/${dataSemZero[0]}`

  // console.log(`::: addScaleShift => DIA SELECIONADO ${ddmmyyyy} (${yyyymd}) EM UMA SEMANA ${args.createShift ? 'JÁ DISPARADA' : 'NÃO DISPARADA'}:`, args)

  let firebasePaths = {}

  //
  // COLOCA PLANTÃO NO EDITAR ESCALA
  //

  const dbRefDate = `escalas/${args.groupID}/${args.scaleID}/turnos/${args.turnID}/plantoes/${yyyymd}/users`
  const refKey = apiGenerateEntityID(dbRefDate)
  const dbReferenceID = `${dbRefDate}/${refKey}`

  firebasePaths = { [dbReferenceID]: args.user }

  //
  // CRIA PLANTÃO
  //

  if (args.createShift)
  {
    // testar - SENHOR JESUS
    const datetime = [parseInt(dataSemZero[0]), parseInt(dataSemZero[1]) - 1, parseInt(dataSemZero[2]), 0, 0, 0, 0]
    const dutyStartDate = moment.utc(datetime).unix() * 1000

    const dutyDuration = valueToDB(args.turnoDados.duration)

    const turnValue = !!args.turnoDados.value === true ? args.turnoDados.value : 0

    const dutyDurationHHMM = formatDbTime(args.turnoDados.duration)

    // ---------------------------------------------------------------------------------
    // Calcula o valor do plantão usando a hierarquia de precificação completa
    const dutyStartTime = valueToTime(args.turnoDados.hour)


    const dutyValueBasedOnUserScaleHourlyRate = calculateAutomaticDutyValue(
      args.userData,
      args.scaleData,
      yyyymd,
      dutyStartTime,
      dutyDurationHHMM,
      turnValue
    )


    // ---------------------------------------------------------------------------------

    const pathShiftDate = `escalas/${args.groupID}/${args.scaleID}/turnos/${args.turnID}/plantoes/${yyyymd}`

    var loggedUser = apiGetCurrentUser()

    const newDutyObject = createDutyObject({
      /*
      // [staging-portaltelemedicina / master-portaltelemedicina]
      slotType: args.slotType,
      scaleConsultationDuration: args.scaleConsultationDuration,
      // [staging-portaltelemedicina / master-portaltelemedicina]
      */

      dutyGroupID: args.groupID, // *
      dutyScaleID: args.scaleID, // *
      dutyCreatorID: loggedUser.uid, // *
      dutyOwnerID: isAvailableShift ? 0 : args.user.uid, // *

      dutyMessageDate: ddmmyyyy, // `${dutyDateSplit[0]}/${dutyDateSplit[1]}/${dutyDateSplit[2]}`,
      dataInicioFmt: yyyymd, // dutyDate,

      dutyStartDate, // *
      dutyStartTime: valueToTime(args.turnoDados.hour), // *
      dutyDuration, // *
      shiftName: args.turnoDados.name ? args.turnoDados.name : '',

      dutyName: args.scaleName,
      dutyLocal: args.scaleLocation.name, // *

      dutyValue: turnValue || dutyValueBasedOnUserScaleHourlyRate,

      preventAvailableDutyNotification: false, // notificar plantão do tipo disponível
      // isUserDuty: isAvailableShift ? false : true, // *
      isUserDuty: isAvailableShift === false, // *
      updateGroup: true,
      turnPath: pathShiftDate,

      dutyCreatorName: loggedUser.displayName,
      dutyGroupName: args.grupoNome,
    })

    firebasePaths = {
      ...firebasePaths,
      ...newDutyObject,
    }

    firebasePaths[pathShiftDate + '/confirmedDutys'] = true
  }

  //
  // OUTPUT
  //

  return {
    firebasePaths,
    path: dbReferenceID,
  }
}

export const createShift = async (args = {
  /*
  // [staging-portaltelemedicina / master-portaltelemedicina]
  slotType: "",
  scaleConsultationDuration: false,
  // [staging-portaltelemedicina / master-portaltelemedicina]
  */

  user: { availableTurn: true },
  userScaleHourlyRate: 0,
  weeks: [],
  jornada: '',
  journeyWorkingDays: '',
  journeyDaysOff: '',
  turnID: '',
  dataSemZero: '', // YYYY-M-D
  turnoDados: null,
  groupID: '',
  scaleID: '',
  grupoNome: '',
  scaleName: '',
  scaleLocation: '',
  //
}) => {
  // console.log('::: createShift => args:', args)

  let firebasePaths = {}
  const references = []
  const datesOutput = []

  //
  // Manual
  //

  if (args.jornada === 'Manual')
  {
    const isReleasedWeek = args.weeks.some(week => week.value.some(weekDay => weekDay.dayFmtWzero === args.dataSemZero) && week.isReleasedWeek)

    const added = addScaleShift({ ...args, createShift: isReleasedWeek })

    firebasePaths = added.firebasePaths

    if (!isReleasedWeek) references.push(added.path)

    datesOutput.push(args.dataSemZero)
  }

  //
  // Jornada
  //

  else
  {
    // LÊ OS DIAS DA SEMANA QUE FAZEM PARTE DO TURNO (QUE O USUÁRIO ESTÁ SENDO INSERIDO)
    const detalhesDoTurno = await apiGetTurnDays(args.groupID, args.scaleID, args.turnID)
    const diasDoTurno = !!detalhesDoTurno && !!detalhesDoTurno.days && Array.isArray(detalhesDoTurno.days) ? detalhesDoTurno.days : []

    if (diasDoTurno.length === 0) return { code: 0, firebasePaths: null, references: [], dates: [] }

    // DATAS PARA INSERÇÃO CONFORME A JORNADA SELECIONADA
    const dates = getWorkingDays(args.weeks, diasDoTurno, args.dataSemZero, args.jornada, args.journeyWorkingDays, args.journeyDaysOff)

    // DATABASE PATH'S
    dates.forEach(date => {
      const addedDate = addScaleShift({ ...args, dataSemZero: date.dataSemZero, createShift: date.isReleasedWeek })

      firebasePaths = { ...firebasePaths, ...addedDate.firebasePaths }

      if (!date.isReleasedWeek) references.push(addedDate.path)

      datesOutput.push(date.dataSemZero)
    })
  }

  //
  // OUTPUT
  //

  return { code: 1, firebasePaths, references, dates: datesOutput }
}
